import React, { Fragment } from 'react';
import styled from 'styled-components';
import { typeStyle, mediaQuery } from '@carvana/showroom-css-theme';

export type DropdownItem = {
  label: string;
  url: string;
};

type DropdownProps = {
  items: Array<DropdownItem>;
};

const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0px 0px 32px;
  gap: 16px;
  ${mediaQuery('l')} {
    padding: 24px 0;
    gap: 24px;
    border-radius: 9px;
    justify-content: center;
    align-items: center;
    background: var(--cvna-color-white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

    ::after {
      transform: rotate(0deg);
      top: 8px;
      right: 11%;
      border-width: 0px 8px 8px;
      content: '';
      position: absolute;
      border-style: solid;
      border-color: var(--cvna-color-white) transparent;
    }
  }
`;

const DropdownListItem = styled.div`
  width: 100%;
  ${mediaQuery('l')} {
    padding: 0 16px;
    text-align: center;
  }
`;

const DropdownLink = styled.a<{ isActive: boolean }>`
  ${typeStyle('label-m')};
  cursor: pointer;
  transition: color 150ms ease-in-out;
  color: var(--cvna-color-blue-6);
  border-bottom: 4px solid;
  border-color: ${({ isActive }) =>
    isActive ? 'var(--cvna-color-blue-2)' : 'transparent'};
  transition: color 150ms ease-in-out;
  :hover {
    text-decoration: none;
    color: var(--cvna-color-blue-2);
  }
`;

const HoverWrapper = styled.div`
  width: 100%;
  ${mediaQuery('l')} {
    width: auto;
    display: block;
    position: absolute;
    padding-top: 16px;
    transform: translate(-80%);
  }
`;

const Dropdown: React.FC<DropdownProps> = ({ items }) => {
  let currHref = '';
  if (typeof window !== 'undefined') {
    currHref = window.location.href;
  }

  return (
    <div>
      <HoverWrapper>
        <DropdownContent>
          {items.map(({ label, url }) => (
            <Fragment key={label}>
              <DropdownListItem>
                <DropdownLink href={url} isActive={currHref.includes(url)}>
                  {label}
                </DropdownLink>
              </DropdownListItem>
            </Fragment>
          ))}
        </DropdownContent>
      </HoverWrapper>
    </div>
  );
};

export default Dropdown;
